import { Ref, JSX } from 'preact';
import { forwardRef } from 'preact/compat';

export type ButtonUnstyledProps<
  T extends keyof JSX.IntrinsicElements = 'button',
> = {
  component?: T;
} & JSX.IntrinsicElements[T];

const ButtonUnstyledInner = <T extends keyof JSX.IntrinsicElements = 'button'>(
  { component, ...props }: ButtonUnstyledProps<T>,
  ref: Ref<JSX.IntrinsicElements[T]>
) => {
  const Component = component ?? 'button';

  // see `usePlayerInteraction` hook implementation
  // @ts-expect-error Expression produces a union type that is too complex to represent.
  return <Component {...props} data-action ref={ref} />;
};

export const ButtonUnstyled = forwardRef(ButtonUnstyledInner) as <
  T extends keyof JSX.IntrinsicElements = 'button',
>(
  props: ButtonUnstyledProps<T>
) => ReturnType<typeof ButtonUnstyledInner>;
